import { IRestClient, RestClient } from 'services/clients/RestClient';
import { IRequestHeader } from 'services/driverPortal/AuthenticationService.interface';

class NotFound extends Error {}

const baseURL = process.env.REACT_APP_ALL_NOW_UTIL_URL || '';
const apiKey = process.env.REACT_APP_DRIVER_PORTAL_API_KEY || '';

export enum ReaderType {
  DRIVING_LICENSE = 'rider_driving_license',
  PERSONAL_ID = 'rider_personal_id',
  RIDER_VEHICLE_REGIST_BOOK = 'rider_vehicle_registration_book',
  RIDER_ACT = 'rider_act',
  RIDER_TAX = 'rider_tax',
  BOOK_BANK = 'rider_book_bank',
  RIDER_HOUSE_REGISTRATION = 'rider_house_registration',
  RIDER_VOLUNTARY_MOTORCYCLE_INSURANCE = 'rider_voluntary_motorcycle_insurance',
}

export class DocumentReaderService {
  private restClient: IRestClient;
  constructor() {
    this.restClient = new RestClient({
      baseURL,
    });
  }

  private buildRequestHeaders(req: IRequestHeader) {
    return {
      'api-key': req?.apiKey,
    };
  }

  // async readerFile(file: File, type: string) {
  //   const path = '/ai/document_reader';
  //
  //   const formData = new FormData();
  //   formData.set('file', file);
  //   formData.set('type', type);
  //
  //   return this.restClient.post<any>(path, {
  //     data: formData,
  //     headers: this.buildRequestHeaders({
  //       apiKey: 'F@IWFE012DP%7EweF*W70OKK#E',
  //     }),
  //   });
  // }

  async readerFile(file: File, type: string) {
    const path = '/ai/document_reader';

    const formData = new FormData();
    formData.set('file', file);
    formData.set('type', type);
    try {
      const raw = localStorage.getItem('driver-portal-profile');
      if (raw) {
        const profile = JSON.parse(raw);
        const user = profile?.data ?? profile;
        formData.set('user', JSON.stringify(user));
        // if (user?.userId != null) formData.set('userId', String(user.userId));
        // if (user?.userName)       formData.set('userName', user.userName);
        // if (Array.isArray(user?.roles)) formData.set('roles', JSON.stringify(user.roles));
      }
    } catch (e) {
      console.warn('Parse driver-portal-profile failed:', e);
    }
    return this.restClient.post<any>(path, {
      data: formData,
      headers: this.buildRequestHeaders({
        apiKey: 'F@IWFE012DP%7EweF*W70OKK#E',
      }),
      withCredentials: false,
    });
  }
}
